import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideCoreService } from './core/utils/service-provider.util';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';

//App Services - Start
import { AuthService } from './modules/auth/services/auth.service';
import { AuthApiService } from './modules/auth/services/auth.api.service';
import { AuthMockService } from './modules/auth/services/auth.mock.service';
import { InstitutionService } from './modules/protected/services/institution/institution.service';
import { InstitutionApiService } from './modules/protected/services/institution/institution.api.service';
import { InstitutionMockService } from './modules/protected/services/institution/institution.mock.service';
import { BatchService } from './modules/protected/services/batch/batch.service';
import { BatchApiService } from './modules/protected/services/batch/batch.api.service';
import { BatchMockService } from './modules/protected/services/batch/batch.mock.service';
import { StaffService } from './modules/protected/services/institution/staff.service';
import { StaffApiService } from './modules/protected/services/institution/staff.api.service';
import { StaffMockService } from './modules/protected/services/institution/staff.mock.service';
import { ProfileCompletionService } from './modules/protected/services/profile/profile.completion.service';
import { ProfileCompletionApiService } from './modules/protected/services/profile/profile.completion.api.service';
import { ProfileCompletionMockService } from './modules/protected/services/profile/profile.completion.mock.service';
import { CandidateService } from './modules/protected/services/candidate/candidate.service';
import { CandidateApiService } from './modules/protected/services/candidate/candidate.api.service';
import { CandidateMockService } from './modules/protected/services/candidate/candidate.mock.service';
import { PackageService } from './modules/protected/services/package/package.service';
import { PackageApiService } from './modules/protected/services/package/package.api.service';
import { PackageMockService } from './modules/protected/services/package/package.mock.service';
import { SessionService } from './modules/protected/services/package/session.service';
import { SessionApiService } from './modules/protected/services/package/session.api.service';
import { SessionMockService } from './modules/protected/services/package/session.mock.service';

import { MasterConfigService } from './core/services/master-config/master-config.service';
import { MasterConfigApiService } from './core/services/master-config/master-config.api.service';
import { MasterConfigMockService } from './core/services/master-config/master-config.mock.service';
import { CareerSetupService } from './core/services/career-setup/career-setup.service';
import { CareerSetupMockService } from './core/services/career-setup/career-setup.mock.service';
import { StageSetupService } from './core/services/career-setup/stage-setup.service';
import { StageSetupApiService } from './core/services/career-setup/stage-setup.api.service';
import { StageSetupMockService } from './core/services/career-setup/stage-setup.mock.service';
import { RoleSkillSetupService } from './core/services/career-setup/role-skill-setup.service';
import { RoleSkillSetupApiService } from './core/services/career-setup/role-skill-setup.api.service';
import { RoleSkillSetupMockService } from './core/services/career-setup/role-skill-setup.mock.service';
import { AssessmentSetupService } from './core/services/career-setup/assessment-setup.service';
import { AssessmentSetupApiService } from './core/services/career-setup/assessment-setup.api.service';
import { AssessmentSetupMockService } from './core/services/career-setup/assessment-setup.mock.service';
import { AssessmentTopicService } from './core/services/career-setup/assessment-topic.service';
import { AssessmentTopicApiService } from './core/services/career-setup/assessment-topic.api.service';
import { AssessmentTopicMockService } from './core/services/career-setup/assessment-topic.mock.service';
import { QuestionService } from './core/services/career-setup/question.service';
import { QuestionApiService } from './core/services/career-setup/question.api.service';
import { QuestionMockService } from './core/services/career-setup/question.mock.service';
//App Services - End


import {
  LucideAngularModule,
  Rocket,
  Sun,
  Moon,
  ArrowUp,
  Video,
  Users,
  Activity,
  ArrowRight,
  ArrowLeft,
  Send,
  RefreshCcw,
  Pencil,
  X,
  Smartphone,
  Download,
  FileText,
  MailOpen,
  Briefcase,
  Award,
  GraduationCap,
  TrendingUp,
  Settings,
  Search,
  Bell,
  LogOut,
  ChevronRight,
  Headphones,
  Building,
  Info,
  Cpu,
  MapPin,
  ChevronDown,
  Plus,
  Clock,
  ChartPie,
  CheckCircle,
  Zap,
  PartyPopper,
  User,
  Layers,
  Landmark,
  Phone,
  Trash2,
  FileUp,
  Link,
  UserPlus,
  ChartSpline,
  Lock,
  Hourglass,
  QrCode,
  CloudUpload,
  Copy,
  House,
  BadgeInfo,
  SquareTerminal,
  Map,
  Brain,
  UserStar,
  LandmarkIcon,
  List,
  Globe,
  DollarSign,
  Mail,
  Shield,
  Calendar,
  Filter,
  Grid,
  MoreVertical,
  RefreshCw,
  CheckCircle2,
  BarChart2,
  Check,
  CalendarCheck,
  Hash,
  LayoutDashboard,
  Package
} from 'lucide-angular';
import { CareerService } from './modules/protected/services/career/career.service';
import { CareerApiService } from './modules/protected/services/career/career.api.service';
import { CareerMockService } from './modules/protected/services/career/career.mock.service';
import { AllocationService } from './modules/protected/services/allocation/allocation.service';
import { AllocationApiService } from './modules/protected/services/allocation/allocation.api.service';
import { AllocationMockService } from './modules/protected/services/allocation/allocation.mock.service';
import { UserService } from './modules/protected/services/user/user.service';
import { UserApiService } from './modules/protected/services/user/user.api.service';
import { UserMockService } from './modules/protected/services/user/user.mock.service';
import { TeamService } from './modules/protected/services/team/team.service';
import { TeamApiService } from './modules/protected/services/team/team.api.service';
import { TeamMockService } from './modules/protected/services/team/team.mock.service';
import { CareerSetupApiService } from './core/services/career-setup/career-setup.api.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(),
    importProvidersFrom(
      LucideAngularModule.pick({
        Rocket,
        Hash,
        Sun,
        Moon,
        BadgeInfo,
        ArrowUp,
        Video,
        Users,
        Activity,
        ArrowRight,
        ArrowLeft,
        Send,
        RefreshCcw,
        Pencil,
        X,
        Smartphone,
        Download,
        FileText,
        Mail,
        MailOpen,
        House,
        Briefcase,
        Award,
        GraduationCap,
        TrendingUp,
        Settings,
        Search,
        Bell,
        LogOut,
        ChevronRight,
        Headphones,
        Building,
        Info,
        Cpu,
        MapPin,
        ChevronDown,
        Plus,
        Clock,
        CheckCircle,
        Zap,
        PartyPopper,
        User,
        Calendar,
        Layers,
        Landmark,
        Phone,
        Trash2,
        FileUp,
        Link,
        UserPlus,
        ChartSpline,
        Lock,
        Hourglass,
        QrCode,
        CloudUpload,
        Copy,
        ChartPie,
        SquareTerminal,
        Map,
        Brain,
        UserStar,
        LandmarkIcon,
        List,
        Globe,
        DollarSign,
        Shield,
        Filter,
        Grid,
        MoreVertical,
        RefreshCw,
        CheckCircle2,
        BarChart2,
        Check,
        CalendarCheck,
        LayoutDashboard,
        Package
      })
    ),
    provideCoreService(AuthService, AuthApiService, AuthMockService),
    provideCoreService(InstitutionService, InstitutionApiService, InstitutionMockService),
    provideCoreService(BatchService, BatchApiService, BatchMockService),
    provideCoreService(CareerService, CareerApiService, CareerMockService),
    provideCoreService(UserService, UserApiService, UserMockService),
    provideCoreService(TeamService, TeamApiService, TeamMockService),
    provideCoreService(StaffService, StaffApiService, StaffMockService),
    provideCoreService(CandidateService, CandidateApiService, CandidateMockService),
    provideCoreService(PackageService, PackageApiService, PackageMockService),
    provideCoreService(SessionService, SessionApiService, SessionMockService),
    provideCoreService(AllocationService, AllocationApiService, AllocationMockService),
    provideCoreService(ProfileCompletionService, ProfileCompletionApiService, ProfileCompletionMockService),
    provideCoreService(MasterConfigService, MasterConfigApiService, MasterConfigMockService),
    provideCoreService(CareerSetupService, CareerSetupApiService, CareerSetupMockService),
    provideCoreService(StageSetupService, StageSetupApiService, StageSetupMockService),
    provideCoreService(RoleSkillSetupService, RoleSkillSetupApiService, RoleSkillSetupMockService),
    provideCoreService(AssessmentSetupService, AssessmentSetupApiService, AssessmentSetupMockService),
    provideCoreService(AssessmentTopicService, AssessmentTopicApiService, AssessmentTopicMockService),
    provideCoreService(QuestionService, QuestionApiService, QuestionMockService),
  ]
};
